import React from 'react';
import { Link } from 'react-router';
import { Button, Icon } from 'semantic-ui-react';

const NotFoundPage = () => {
    document.title = "Flagship / Error";
    return (
      <div>
          <div id="view-header-section">
              <h1 className="view-title">Oops, something went wrong!</h1>
              <p className="white-text">This feature is either broken or coming soon.</p>
          </div>
          <Button as={Link} to="/" className="back-to-dash">
              <Icon name="left arrow"/>
              Back to Dashboard
          </Button>
      </div>
    );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/views/NotFoundPage.js